





















	import Component, { mixins } from "vue-class-component";
	import Project from "@/lib/Project";
	import TaskFinishParam from "@/lib/TaskFinishParam";
	import { Prop } from "vue-property-decorator";
	import ProjectHelper from "@/mixins/ProjectHelper";
	import { colorList } from "@/constants/colorList";
import TargetTask from "@/lib/TargetTask";

	@Component
	export default class AddProjectDialog extends mixins(ProjectHelper) {

		@Prop({ type: Boolean, required: true })
		visible! : boolean;

		//       @Prop({type:String})
		//       projectId!:string;

		@Prop({ type: String })
		taskId! : string;

		remark = "";
		projectColor = "";
		content = "";

		focused = false;

		colorList = colorList;

		created() : void {
			if (this.taskId === undefined) {
				this.content = "";
				this.projectColor = colorList[0].base;
			} else {
				const taskItem = (this.$store.state.targetTaskList as TargetTask[]).find(p => p.id === this.taskId);
				if (taskItem === undefined) {
					throw new Error(`can't find task of id: ${this.taskId}, please check your prop value`);
				} else {
					this.content = taskItem.content;
                    const project = (this.$store.state.projectList as Project[]).find(p => p.id === taskItem.targetId);
                    if (project === undefined){
                        this.projectColor = colorList[0].base;
                    }else {
                        this.projectColor = project.color;
                    }
				}
			}
		}

		finishTask() : void {
            const param = new TaskFinishParam()
            param.id = this.taskId;
            param.remark = this.remark;
            this.$store.commit("finishTask", param);
			this.$message({
				message: '距离年度目标又进一步~',
				type: 'info',
				showClose: true,
			});
			// const project = new Project();

			// if(this.projectId === undefined ) { 
			//   project.id = createId("project").toString()
			// } else {
			//   project.id = this.projectId;
			// }
          
			// project.color = this.proj

			this.$emit('update:visible', false);
		}

		selectColor(color : string) : void {
			this.projectColor = color;
		}

		close() : void {
			this.$emit('update:visible', false);
		}

	}
